module.exports = __webpack_public_path__ + "img/icon2.a1352218.png";